export default "__VITE_ASSET__ZXLNZCV$__"